var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcContentCopy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "yax339xdoa",
    d: "M14.667.917h-11c-1.009 0-1.834.825-1.834 1.833v12.833h1.834V2.75h11V.917zm2.75 3.666H7.333c-1.008 0-1.833.825-1.833 1.834V19.25c0 1.008.825 1.833 1.833 1.833h10.084c1.008 0 1.833-.825 1.833-1.833V6.417c0-1.009-.825-1.834-1.833-1.834zm0 14.667H7.333V6.417h10.084V19.25z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2,
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "59csus17qb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yax339xdoa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#59csus17qb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.833V45.833H0z",
    transform: "translate(-11.917 -11.917)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcContentCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-content-copy.0d7b1942.svg";
export { ForwardRef as ReactComponent };